import type { NuxtApp } from '#app'
import type { GQLPageMeta } from '@core/composables/use-page-meta/generated/page-meta'
import type { GQLPage, GQLPageVariables } from './generated/page'
import type { GQLSlice } from '@core/components/page-body/generated/slices'
import { getCacheOption } from '@core/plugins/apollo/cache-option'
import QUERY from './page.graphql'

export async function queryPage(
  nuxtApp: NuxtApp,
  slug: string,
  pattern = '',
  domain: string = 'monito',
  imtLanding = false,
): Promise<{ body: GQLSlice[]; landingContent?: GQLSlice[] | null; page: GQLPageMeta }> {
  const { $apollo, $isPreview, $reporter, $lang } = nuxtApp
  const _slug = slug.endsWith('/') ? slug.slice(0, -1) : slug
  const { data, errors } = await $apollo.query<GQLPage, GQLPageVariables>({
    query: QUERY,
    variables: {
      lang: $lang,
      slug: _slug,
      pattern,
      imtLanding,
      domain,
      preview: $isPreview.value,
    },
    context: { cache: getCacheOption($isPreview.value) },
  })
  if (errors) {
    throw createGraphQLError(errors, 'Failed to load page')
  }
  if ($reporter.errors.length && !data.page) {
    throw new Error(`Cannot render due to error: ${$reporter.errors[0].message}`)
  }
  if (!data.page) {
    throw new NotFoundError(`Page not found: slug: ${slug}, pattern: ${pattern}`)
  }

  const { body, landingContent, ...page } = data.page
  const activeLanguages = getActiveLanguages(nuxtApp.$config.public.name)
  const filtered = page.alternateLanguages.filter(({ language }) =>
    activeLanguages.includes(language),
  )
  return {
    body,
    landingContent,
    page: {
      ...page,
      alternateLanguages: filtered.length
        ? filtered
        : [{ language: $lang, slug: nuxtApp.$config.public.siteUrl + _slug }],
    },
  }
}
